import React from 'react';
import { useDispatch } from 'react-redux';
import ContextMenu from '@avtechsoftware/react-component-library/src/components/common/ContextMenu/ContextMenu';
import ContextMenuItem
  from '@avtechsoftware/react-component-library/src/components/common/ContextMenu/ContextMenuItem/ContextMenuItem';
import PropTypes from 'prop-types';
import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import { useHistory } from 'react-router-dom';
import HasRolePrivileges from '../../../../../highorder/HasRolePrivileges';
import { RaaRoles } from '../../../../../../utility/SecurityRules';
import envConfig from '../../../../../../envConfig';
import DeleteConfirmationModal from '../../../../../common/DeleteConfirmationModal';
import { connectModalContainerContextToComponent } from '../../../../../../contexts/ModalContext/ModalContext';
import { deleteQuietTime } from '../../../../../../redux/slices/quietTimesSlice/quietTimesSlice';
import quietTimePropType from '../../../../../../utility/PropTypes/quietTimePropType';
import CannotDeleteInUseModal from '../../../../../common/CannotDeleteInUseModal';
import { BulkAlertingResourceType } from '../../../../../../utility/types/BulkAlertingResourceType';
import { setAppliedAlertSearch } from '../../../../../../redux/slices/alertListSlice/alertListSlice';
import FacetId from '../../../../../../utility/types/facetType';
import { formatSchedules } from '../../../../../../utility/quietTimeUtil';

function QuietTimeListTableRow({ quietTime, setModalJSX }) {
  const dispatch = useDispatch();
  const hasSchedules = quietTime.quietTimeScheduleTimePeriodList
      && quietTime.quietTimeScheduleTimePeriodList.length > 0;
  const history = useHistory();
  // todo: list of schedule time period strings
  const getIncludesString = () => (hasSchedules
    ? formatSchedules(quietTime.quietTimeScheduleTimePeriodList) : '');
  const getUsedInCount = () => quietTime && quietTime.alertCount > 0;

  const includeString = getIncludesString();

  const handleSafeDelete = (event) => {
    event.stopPropagation();
    const isInUse = getUsedInCount();
    if (isInUse && isInUse > 0) {
      setModalJSX(
        <CannotDeleteInUseModal
          itemName={quietTime.name}
          itemType={BulkAlertingResourceType.QUIET_TIME}
        />,
      );
    } else {
      setModalJSX(
        <DeleteConfirmationModal
          itemName={quietTime.name}
                // isButtonDisabled={deleteInProgress}
          handleDelete={() => {
            dispatch(deleteQuietTime(quietTime.id));
            setModalJSX(<></>);
          }}
        />,
      );
    }
  };
  return (
    <tr>
      <td className="ellipsis width-25">
        <span className="ml-1">
          {quietTime.name}
        </span>
      </td>
      <td className="ellipsis width-25" title={includeString}>
        <span className="ml-1 pr-1">
          {includeString}
        </span>
      </td>
      <td className="width-15">
        <span className="ml-1">
          <button
            type="button"
            className="btn btn-link p-0"
            title=""
            onClick={async () => {
              await dispatch(setAppliedAlertSearch({
                filters: [{
                  id: null,
                  facetId: FacetId.ALERT_QUIET_TIME,
                  operatorId: OperatorTypes.EQUAL_TO_VALUE,
                  value1: quietTime.id.toString(),
                }],
              }));
              history.push('/s/alerts');
            }}
          >
            {quietTime.alertCount}
            {' '}
            {quietTime.alertCount === 1 ? 'alert' : 'alerts'}
          </button>
        </span>
      </td>
      <td className="width-10">
        <ContextMenu classname="overflow-visible">
          <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
            <>
              <ContextMenuItem
                itemIcon="pencil"
                itemText="Edit"
                onClickHandler={(event) => {
                  event.stopPropagation();
                  window.location.assign(
                    `${envConfig.raaUrl}/s/actions/quiet-times/edit/${quietTime.id}`,
                  );
                }}
              />
              <ContextMenuItem
                itemIcon="copy"
                itemText="Clone"
                onClickHandler={(event) => {
                  event.stopPropagation();
                  window.location.assign(
                    `${envConfig.raaUrl}/s/actions/quiet-times/clone/${quietTime.id}`,
                  );
                }}
              />
              <ContextMenuItem
                itemIcon="trash"
                itemText="Delete"
                onClickHandler={(event) => handleSafeDelete(event)}
              />
            </>
          </HasRolePrivileges>
        </ContextMenu>
      </td>
    </tr>
  );
}

QuietTimeListTableRow.propTypes = {
  quietTime: PropTypes.shape(quietTimePropType).isRequired,
  setModalJSX: PropTypes.func.isRequired,
};

export default connectModalContainerContextToComponent(QuietTimeListTableRow);
